<template>
    <base-message v-if="Object.keys(data).length" type="is-danger">
        <ul>
            <li v-for="(value, key) in data" :key="key">
                <strong v-if="key === 'non_field_errors'">{{ value[0] }}</strong>
                <strong v-else-if="key === 'detail'">{{ value }}</strong>
                <template v-else>
                    <strong>{{ key }}:</strong>
                    {{ value[0] }}
                </template>
            </li>
        </ul>
    </base-message>
</template>

<script>
export default {
    name: 'BackendErrors',
    props: { data: Object },
};
</script>
